import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, CircularProgress, Box } from "@mui/joy";
import { AuthLayout } from "../components/auth/AuthLayout";
import { UsernameSelector } from "../components/auth/UsernameSelector";
import { useAuthStore } from "../store/authStore";

export const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const { profile, session, initialized } = useAuthStore();

  // Redirect if not authenticated
  useEffect(() => {
    if (initialized && !session) {
      navigate("/");
    }
  }, [initialized, session, navigate]);

  // Redirect if user already has a username
  useEffect(() => {
    if (profile?.username) {
      navigate("/");
    }
  }, [profile, navigate]);

  // Show loading while checking auth state
  if (!initialized) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#FDF8F5",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AuthLayout
      title="Almost there!"
      subtitle="Choose a username so other travel buddies can find you 🥵"
    >
      <Typography
        level="body-sm"
        sx={{ mb: 3, color: "#6B6B6B", textAlign: "center" }}
      >
        This is how you&apos;ll appear to other users
      </Typography>

      <UsernameSelector onSuccess={() => navigate("/")} />
    </AuthLayout>
  );
};
